<template>
  <table class="mainTable m-3 p-4 h-100 w-100">
    <thead>
      <tr>
        <td>
          <div style="text-align: center; width: 100%">
            <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="content" style="padding: 15px">
            <div
              style="
                border: 1px solid black;
                border-radius: 10px;
                padding: 0 10px;
                margin-bottom: 10px;
              "
            >
              <div style="text-align: center">
                <span style="font-size: 20px">پیش فاکتور</span>
              </div>
              <br />
              <div>
                <table style="border: 0px solid black !important">
                  <tr>
                    <td style="border: 0px solid black !important">
                      خریدار:
                      <span style="font-size = 16px">{{
                        invoiceData.shopCustomerName +
                        " (" +
                        invoiceData.shopCustomerCode +
                        ")"
                      }}</span>
                    </td>
                    <td
                      style="
                        border: 0px solid black !important;
                        text-align: left;
                      "
                    >
                      شماره:
                      <span style="font-size = 16px">{{
                        invoiceData.code
                      }}</span>
                      (چاپ مجدد)
                    </td>
                  </tr>
                  <tr>
                    <td style="border: 0px solid black !important">
                      نشانی:
                      <span style="font-size = 16px">{{
                        invoiceData.shopCustomerAddress
                      }}</span>
                    </td>
                    <td
                      style="
                        border: 0px solid black !important;
                        text-align: left;
                      "
                    >
                      تاریخ:
                      <span style="font-size = 16px">{{
                        invoiceData.date
                      }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <br />
              <div>
                <span style="float: right"> </span>
                <span style="float: left"> </span>
              </div>
            </div>
            <b-table
              bordered
              :fields="preInvoiceSelectedFields"
              :items="invoiceData.details"
              small="small"
              responsive
            >
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(amount)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value.toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(totalPrice)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{
                    (
                      Number(data.item.amount) * data.item.price
                    ).toLocaleString()
                  }}
                  ریال
                </div>
              </template>
            </b-table>
            <br />
            <div style="width: 100%; margin-bottom: 20px !important">
              <div style="width: 100% !important">
                <div style="width: 50% !important"><span></span></div>
                <div
                  style="
                    width: 50% !important;
                    float: left !important;
                    text-align: left !important;
                  "
                >
                  <span>
                    {{ "جمع کل: " + parseInt(computedPay).toLocaleString() }}
                    ریال
                  </span>
                </div>
              </div>
              <br />
              <div style="width: 100% !important">
                <div style="width: 50% !important"><span></span></div>
                <div
                  style="
                    width: 50% !important;
                    float: left !important;
                    text-align: left !important;
                  "
                >
                  <span>
                    {{
                      "تعداد: " +
                      invoiceData.details
                        .map((x) => Number(x.amount))
                        .reduce((a, b) => a + b, 0)
                    }}
                  </span>
                </div>
              </div>
              <br />
              <div style="width: 100% !important">
                <div style="width: 50% !important"><span></span></div>
                <div
                  style="
                    width: 50% !important;
                    float: left !important;
                    text-align: left !important;
                  "
                >
                  <span>
                    {{
                      "مالیات: " +
                      parseInt(
                        ((invoiceData.details
                          .map((x) => Number(x.price) * Number(x.amount))
                          .reduce((a, b) => a + b, 0) -
                          invoiceData.discount) *
                          invoiceData.vat) /
                          100
                      ).toLocaleString()
                    }}
                    ریال
                  </span>
                </div>
              </div>
              <br />
              <div style="width: 100% !important">
                <div style="width: 50% !important"><span></span></div>
                <div
                  style="
                    width: 50% !important;
                    float: left !important;
                    text-align: left !important;
                  "
                >
                  <span>
                    {{ "تخفیف: " + invoiceData.discount.toLocaleString() }}
                    ریال
                  </span>
                </div>
              </div>
              <br />
              <div style="width: 100% !important">
                <div
                  style="
                    width: 50% !important;
                    float: right !important;
                    text-align: right !important;
                  "
                >
                  <span>
                    مبلغ پرداخت به حروف:
                    <numberToWords :number="computedPay" v-slot="{ words }">
                      <span>
                        {{ words + " ریال " }}
                      </span></numberToWords
                    ></span
                  >
                </div>
                <div
                  style="
                    width: 50% !important;
                    float: left !important;
                    text-align: left !important;
                  "
                >
                  <span>
                    {{
                      " مبلغ قابل پرداخت: " +
                      Number(invoiceData.totalCost).toLocaleString()
                    }}
                    ریال
                  </span>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div
              style="
                border: 1px solid black;
                border-radius: 10px;
                padding: 10px;
                min-height: 75px;
                break-inside: avoid;
              "
            >
              <span> توضیحات: {{ invoiceData.description }}</span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { numberToWords } from "@persian-tools/vue-persian-tools/dist/modules";
export default {
  components: { numberToWords },
  props: ["invoiceData"],
  data() {
    return {
      preInvoiceSelectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
      ],
    };
  },
  computed: {
    computedPay() {
      return Number(
        this.invoiceData.details
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0)
      );
    },
  },
};
</script>
